import { useCallback } from 'react';

import { useLoi } from '../../../hooks/useLoi';
import { useT } from '../../../i18n';
import { maLoi, type ApiError } from '../../../lib/errors';
import { layTuChoi } from '../../../lib/repositories/tro-ly-ai.repository';

/**
 * Câu mô tả lỗi NÊU ĐƯỢC CHỖ SAI, khi máy chủ nói được — port `mo-ta-loi.ts` của native.
 *
 * - Từ chối của bộ canh cổng SQL (`details.refusals`): mỗi dòng là một câu người đọc SỬA ĐƯỢC, nên giữ nguyên cấu trúc
 *   `mã: câu` thay vì rút gọn thành một câu chung.
 * - `403` kèm ĐÚNG LÝ DO máy chủ nêu: module trả 403 cho nhiều việc khác hẳn nhau (chưa có vai, vai không sửa được cấu
 *   hình…), mỗi việc một cách sửa. Câu chung "Bạn không có quyền…" một mình nuốt mất lý do ấy.
 * - Còn lại: `useLoi` của kho (mã chung → catalog, mã nghiệp vụ → `detail` nguyên văn của backend).
 */
export function useMoTaLoi(): (e: unknown) => string {
  const { t } = useT();
  const dichLoi = useLoi();
  return useCallback(
    (e: unknown) => {
      const tuChoi = layTuChoi(e);
      if (tuChoi.length) return tuChoi.map((r) => `${r.code}: ${r.message}`).join(' · ');
      const ma = maLoi(e);
      const cau = (e as ApiError | undefined)?.message?.trim();
      if ((ma === 'PERMISSION_DENIED' || ma === 'FORBIDDEN') && cau) return `${t('loi.khongCoQuyen')} ${cau}`;
      if (e instanceof Error && !ma && e.message) return e.message;
      return dichLoi(e);
    },
    [t, dichLoi],
  );
}
